import * as yup from "yup";

import { locationRequiresContact } from "services/api/fleet/vehicles/locations/consts";
import { VehicleLocationTypeEnum } from "services/api/fleet/vehicles/locations/types";

/**
 * Shema lokacije. Obavezna polja ovise o vrsti i moraju odgovarati provjeri koju backend
 * radi u `BuildVehicleLocationAsync` — inače bi forma propustila unos koji API odbija.
 */
export const VEHICLE_LOCATION_SCHEMA = yup.object().shape({
  locationType: yup
    .string()
    .nullable()
    .required("Vrsta lokacije je obavezan podatak"),

  officeId: yup
    .string()
    .nullable()
    .when("locationType", {
      is: VehicleLocationTypeEnum.OFFICE,
      then: (schema) => schema.required("Poslovnica je obavezan podatak"),
    }),

  // Popis vrsta koje traže kontakt stoji u konstantama, uz `RequiresContact` na backendu —
  // vlastita kopija ovdje je već jednom zaostala (limar i vulkanizer su prolazili prazni).
  contactId: yup
    .string()
    .nullable()
    .when("locationType", {
      is: (value: VehicleLocationTypeEnum | null) => locationRequiresContact(value),
      then: (schema) => schema.required("Odabir je obavezan podatak"),
    }),

  addressLine1: yup
    .string()
    .nullable()
    .when("locationType", {
      is: VehicleLocationTypeEnum.OTHER,
      then: (schema) => schema.required("Adresa je obavezan podatak"),
    }),
});
